import { useQuery } from "@tanstack/react-query";
import type { addressQuerySchema, Address } from "@spare-cart/contracts/checkout";
import type { z } from "@spare-cart/contracts/common";
import { apiClient, toQueryRecord } from "@core/api";
import { addressKeys } from "./addressKeys";

export const useAddresses = (query: z.input<typeof addressQuerySchema> = {}) =>
  useQuery({
    queryKey: addressKeys.list(query),
    queryFn: () => apiClient.list<Address>("/addresses", { query: toQueryRecord(query) }),
  });
